import React, {PropsWithChildren, useEffect, useState} from 'react';
import './modal.scss'

interface Props{
    active: boolean,
    title: string,
    сlose: () => void,
    subtitle?: string
}
const Modal = ({active, title, сlose, subtitle, children}: PropsWithChildren<Props>) => {
    const [closing, setClosing] = useState(false)

    const handleClose = () => {
        setClosing(true)
        setTimeout(() => {
            сlose();
        }, 500)
    }

    useEffect(() => {
        if(active){
            document.body.classList.add('modal-open')
        }
        return() => {
            document.body.classList.remove('modal-open')
        }
    }, [active]);

    // useEffect(() => {
    //     document.body.style.overflow = 'hidden'
    //     return () => {
    //         document.body.style.overflow = 'unset'
    //     }
    // }, []);

    return (
        <>
            {
                active ? <div className={`modal ${closing ? 'modal-closing' : ''}`} onClick={handleClose}>
            <div className="modal__content" onClick={e => e.stopPropagation()}>
                <div className="modal__header">
                    <div className="modalTitle">
                        <p className="modal-close__cross" onClick={handleClose}>&times;</p>
                        <h2>{title}</h2>
                    </div>
                    {subtitle &&
                        <div className="modalTitle">
                            <h2>{subtitle}</h2>
                        </div>
                    }
                </div>
                <div className="modal__body">
                    {children}
                </div>
            </div>
        </div>
                    :
                    <>
                    </>
            }
            </>
    );
};

export default Modal;